import axios from "axios";
import { API_ROOT } from ".";
import { getAuthUser } from "./auth";
import type { PickupLocation } from "./pickupLocations";
import type { Subscription } from "./subscriptions";
import type { SubscriptionTier } from "./tiers";
import { PaymentStatus } from "../components/dashboard/utils/types";

const CSA_SIGNUP_API_URL = `${API_ROOT}/csa-signup`;

function getAuthHeaders(): { Authorization: string } {
  const token = getAuthUser()?.token;
  if (!token) throw new Error("Not authenticated");
  return { Authorization: `Bearer ${token}` };
}

export type CsaSignupPayload = {
  subscriptionTierId: string;
  pickupLocationId: string;
  pickupDay: string;
};

export interface CsaSignupResponse {
  pickupId: string;
  subscriptionPaymentStatus: PaymentStatus;
  payPageUrl: string;
}

export function buildDefaultCsaSignupPayload(
  subscriptions: Subscription[],
  tiers: SubscriptionTier[],
  pickupLocations: PickupLocation[],
): CsaSignupPayload | null {
  const firstSub = subscriptions[0];
  if (!firstSub) return null;
  const firstTier =
    firstSub.tiers?.[0] ??
    tiers.find((t) => t.subscriptionId === firstSub.id) ??
    null;
  const firstLoc = pickupLocations[0];
  const firstDay = firstLoc?.days?.[0];
  if (!firstTier?.id || !firstLoc?._id || !firstDay?.day) return null;

  return {
    subscriptionTierId: firstTier.id,
    pickupLocationId: firstLoc._id,
    pickupDay: firstDay.day,
  };
}

export async function callCsaSignup(
  data: CsaSignupPayload,
): Promise<CsaSignupResponse> {
  const res = await axios.post<CsaSignupResponse>(CSA_SIGNUP_API_URL, data, {
    headers: getAuthHeaders(),
  });
  return res.data;
}
